import React from 'react';

export const FrFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
  >
    <g clipPath="url(#clip0_566_17133)">
      <mask
        id="mask0_566_17133"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <rect width="16" height="12" fill="white" />
      </mask>
      <g mask="url(#mask0_566_17133)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 0H16V12H11V0Z"
          fill="#F50100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H6V12H0V0Z"
          fill="#2E42A5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 0H11V12H5V0Z"
          fill="#F7FCFF"
        />
      </g>
    </g>
    <rect
      x="0.5"
      y="0.5"
      width="15"
      height="11"
      rx="0.5"
      stroke="black"
      strokeOpacity="0.1"
      style={{ mixBlendMode: 'multiply' }}
    />
    <defs>
      <clipPath id="clip0_566_17133">
        <rect width="16" height="12" rx="1" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
